<template>
  <ModalConfirmation
    :showModal="showOauthModal"
    title="Update Credentials"
  >
    <template v-slot:body>
      <ParagraphBody>
        Updating the credentials will cause the existing access token to be revoked
        and replaced with a new token. Are you sure you want to continue?
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <ButtonGroup
        :isFullWidth="false"
      >
        <ButtonSecondary
          text="Cancel"
          @click="$emit('close')"
        />
        <Button
          text="Continue"
          @click="$emit('continue')"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  Button,
  ButtonGroup,
  ButtonSecondary,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'OauthCredentialsWarningModal',

  components: {
    Button,
    ButtonGroup,
    ButtonSecondary,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    showOauthModal: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>

</style>
